export type TokenInfo = {
  readonly chainId: number
  readonly address: string
  readonly name: string
  readonly decimals: number
  readonly symbol: string
  readonly description?: string
  readonly logoURI?: string
}

export const tokens: TokenInfo[] = [
  {
    chainId: 1,
    address: '0xdac17f958d2ee523a2206206994597c13d831ec7',
    name: 'Tether',
    decimals: 6,
    symbol: 'USDT',
    description: 'Ethereum Network (ERC-20 only)',
    logoURI: '/assets/tokens/tether.svg',
  },
  {
    chainId: 1,
    address: '0x6b175474e89094c44da98b954eedeac495271d0f',
    name: 'Bitcoin',
    decimals: 18,
    symbol: 'BTC',
    logoURI: '/assets/tokens/bitcoin.svg',
  },
  {
    chainId: 1,
    address: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
    name: 'Ethereum',
    decimals: 18,
    symbol: 'ETH',
    logoURI: '/assets/tokens/ethereum.svg',
  },
  {
    chainId: 1,
    address: '0x111111111117dc0aa78b770fa6a738034120c302',
    name: 'Litecoin',
    decimals: 18,
    symbol: 'LTC',
    logoURI: '/assets/tokens/litecoin.svg',
  },
  {
    chainId: 1,
    address: '0x514910771af9ca656af840dff83e8264ecf986ca',
    name: 'Primeroll',
    decimals: 18,
    symbol: 'PRLL',
    logoURI: '/assets/tokens/primeroll.svg',
  },
  {
    chainId: 1,
    address: '0x1f9840a85d5af5bf1d1762f925bdaddc4201f984',
    name: 'Solana',
    decimals: 18,
    symbol: 'SOL',
    logoURI: '/assets/tokens/solana.svg',
  },
]
